
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
  props: {
    createdBy: {
      default: "",
      type: String
    },
    updatedBy: {
      default: "",
      type: String
    },
    createdAt: {
      default: "",
      type: [String, Date]
    },
    updatedAt: {
      default: "",
      type: [String, Date]
    }
  }
})
class CreateUpdate extends Vue {
  props: any = this.$props;

  get convertCreatedAt() {
    return formatDate(this.props.createdAt);
  }

  get convertUpdatedAt() {
    return formatDate(this.props.updatedAt);
  }
}
export default CreateUpdate;
